<section class="flex items-center justify-center">
  <span class="loader"> </span>
</section>
